module.exports = __webpack_public_path__ + "img/ganhemais02.2dd22dfe.svg";